import React from "react";
import ModalSideBar from "../../../../components/ModalSideBar";
import { IFinanceiroMovimentacao } from "./types/types";


interface InfoProps {
  data?: IFinanceiroMovimentacao;
  title: string;
  onClose: () => void;
}

const Info: React.FC<InfoProps> = ({ data, title, onClose }) => {
  const formatCurrency = (value: number | string | undefined | null) => {
    if (value === undefined || value === null) return "---";
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) return "---";

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(numericValue);
  };

  const getPagamento = (index: number) => data?.pagamentos?.[index];

  const valorTotalTriagem =
    data?.valor_total_triagem ??
    data?.valor_total_da_triagem ??
    data?.custo_triagem ??
    data?.pagamentos?.reduce((total, pagamento) => total + Number(pagamento.valor_total || 0), 0);

  const paymentFields = [1, 2, 3, 4].flatMap((paymentNumber) => {
    const pagamento = getPagamento(paymentNumber - 1);
    return [
      { label: `Tipo Pagamento ${paymentNumber}`, value: pagamento?.tipo_pagamento },
      { label: `Valor Pagamento ${paymentNumber}`, value: formatCurrency(pagamento?.valor_total) },
    ];
  });

  const hasEstornoInfo = data?.justificativa_estorno !== undefined;

  const fields = [
    { label: "ID Operação Pátio", value: data?.id_operacao_patio },
    { label: "Data Pagamento", value: data?.data_hora_pagamento },
    { label: "Tipo Agendamento", value: data?.tipo_agendamento },
    { label: "Tipo Operação", value: data?.tipo_operacao },
    { label: "Terminal", value: data?.terminal_nome },
    { label: "Terminal CNPJ", value: data?.terminal_cnpj },
    { label: "Transportadora", value: data?.transportadora_nome || (typeof data?.transportadora === 'object' ? data?.transportadora?.razao_social : data?.transportadora) },
    { label: "Transportadora CNPJ", value: data?.transportadora_cnpj },
    { label: "Motorista", value: data?.motorista_nome },
    { label: "CPF Motorista", value: data?.motorista_cpf },
    { label: "Telefone Motorista", value: data?.motorista_telefone },
    { label: "Placa", value: data?.placa },
    { label: "Placa Traseira", value: data?.placa_traseira },
    { label: "Veículo", value: data?.tipo_veiculo },
    { label: "ID Bumerangue", value: data?.id_bumerangue },
    { label: "Identificação Carga", value: data?.identificacao_carga },
    { label: "Label Entrada", value: data?.label_operacao_patio_entrada_veiculos },
    { label: "Container (Agendamento)", value: data?.container_agendamento },
    { label: "Container (Entrada)", value: data?.container_entrada },
    { label: "Data Agendamento", value: data?.data_agendamento },
    { label: "Data Entrada", value: data?.data_hora },
    { label: "Data Saída", value: data?.data_hora_saida },
    { label: "Tempo de Pátio", value: data?.tempo_patio },
    { label: "Pedido", value: data?.pedido },
    { label: "Valor Total Triagem", value: formatCurrency(valorTotalTriagem) },
    { label: "Desconto", value: data?.desconto },
    ...paymentFields,
    { label: "Usuário", value: data?.usuario_pagamento },
    { label: "Supervisor", value: data?.supervisor },
    { label: "Transação", value: data?.numero_transacao },
    ...(data?.justificativa_estorno
      ? [{ label: "Justificativa do Estorno", value: data?.justificativa_estorno }]
      : []),
    ...(hasEstornoInfo
      ? [{
          label: "Situação do Estorno",
          value: data?.estorno_sem_finalizacao
            ? "Não concluida"
            : "Concluida",
        }]
      : []),
    { label: "Tipo de Carga", value: data?.tipo_carga },
    { label: "Horas Extras", value: data?.qtd_horas_extras },
    { label: "Custo Estadia", value: formatCurrency(data?.custo_estadia) },
    { label: "Custo Meia Estadia", value: formatCurrency(data?.custo_meia_estadia) },
    { label: "Custo Hora Extra", value: formatCurrency(data?.custo_hora_extra) },
    { label: "Custo Triagem", value: formatCurrency(data?.custo_triagem) },
  ];

  return (
    <ModalSideBar isOpen title={title} onClose={onClose}>
      <div className="w-full h-[calc(100vh-100px)] p-4 overflow-y-auto overflow-x-hidden">
        <div className="w-full grid grid-cols-2 gap-4">
          {fields.map((field) => (
            <div key={field.label} className="flex flex-col w-full min-w-0">
              <span className="text-sm text-[#1E2121] font-semibold mb-1 truncate">
                {field.label}
              </span>
              <span className="text-sm text-[#666666] font-normal break-words">
                {field.value ?? "---"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
